import { API_BASE_URL } from './apiConfig';

export async function fetchRecordCount(startTime, endTime) {
  try {
    const response = await fetch(`${API_BASE_URL}/data/count?startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch record count: ${response.status}`);
    }

    const data = await response.json();
    return data.result; // Parse 'result' field
  } catch (error) {
    console.error('Error fetching record count:', error);
    return 0; // Fallback to 0 on error
  }
}

// Fetch unique user count from /data/count-unique-users
export async function fetchUniqueUserCount(startTime, endTime) {
  try {
    const response = await fetch(`${API_BASE_URL}/data/count-unique-users?startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // Add authorization header if needed, e.g., 'Authorization': 'Bearer YOUR_TOKEN'
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch unique user count: ${response.status}`);
    }

    const data = await response.json();
    return data.result; // Parse 'result' field
  } catch (error) {
    console.error('Error fetching unique user count:', error);
    return 0; // Fallback to 0 on error
  }
}